import type { Table } from "@tanstack/vue-table";
import type { ButtonProps } from "../button/Button";
import { defineComponent } from "vue";
import { p } from "@/utils/props-builder";
import Button from "../button/Button";
import Tooltip from "../tooltip/Tooltip";

export interface ActionButtonOption extends ButtonProps {
  handler: () => void;
  tooltip?: string;
}

export default defineComponent({
  name: "ActionButtons",
  props: {
    buttons: p.array<ActionButtonOption[]>([]),
    table: p.$object<Table<any>>(),
  },
  setup(props) {
    return () => (
      <div v-show={props.buttons.length} class="center flex-wrap gap-2.5 px-0.5">
        {props.buttons.map((action) => {
          return (
            <Tooltip text={action.tooltip}>
              <div>
                <Button
                  key={action.tooltip}
                  {...action}
                  color={action.color || "brand"}
                  variant="outline"
                  aria-label={action.tooltip}
                  onClick={action.handler}
                  size={action.size || "sm"}
                ></Button>
              </div>
            </Tooltip>
          );
        })}
      </div>
    );
  },
});
